/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable max-len */
import React from 'react';
import {
  makeStyles, Box, Typography, Divider,
} from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import HeaderAndDescription from 'common/components/HeaderAndDescription';
import { withTranslation } from 'config/i18n';
import DisplayMoney from 'utils/displayMoney';

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    fontWeight: '500',
    marginBottom: theme.spacing(1),
  },
  sectionSubTitle: {
    fontWeight: '500',
  },
  chipHolder: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(4),

    '& $sectionSubTitle': {
      marginRight: theme.spacing(2),
    },

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  chip: {
    backgroundColor: 'rgba(139, 208, 203, 0.31)',
    display: 'flex',
    alignItems: 'flex-start',
    padding: theme.spacing(0.5, 1.5),
    borderRadius: 15,
    color: theme.palette.secondary.main,

    '& svg': {
      color: theme.palette.info.main,
      marginRight: theme.spacing(1),
    },
  },
  info: {
    color: theme.palette.grey['300'],
  },
  extras: {
    '& > div': {
      marginBottom: theme.spacing(1.5),
    },
  },
}));

const MostRidersAskAbout = (props) => {
  const classes = useStyles();
  const {
    t, guidelinesAndRestrictions, customizations, optionalUpsells,
  } = props;
  return (
    <>
      <Box>
        <Typography variant="h3" className={classes.sectionTitle}>
          {t('fe_es_vehicle_page:most_riders_ask_about')}
        </Typography>
        {customizations && customizations.length != 0 && (
          <>
            <Typography variant="h4" className={classes.sectionSubTitle}>
              {t('fe_es_vehicle_page:customizations')}
            </Typography>

            <Typography variant="h5" className={classes.info}>
              <div dangerouslySetInnerHTML={{ __html: customizations }} />
            </Typography>
          </>
        )}

        {optionalUpsells && optionalUpsells.length != 0 && (
          <>
            <Box mt={1} mb={2}>
              <Divider />
            </Box>
            <Box className={classes.chipHolder}>
              <Typography variant="h4" className={classes.sectionSubTitle}>
                {t('fe_es_vehicle_page:gears_extras')}
              </Typography>
              <Box className={classes.chip}>
                <InfoIcon />
                <Typography variant="body2">{t('fe_es_vehicle_page:add_these_options')}</Typography>
              </Box>
            </Box>
            <Box className={classes.extras}>
              {optionalUpsells.map((item) => (
                <HeaderAndDescription
                  key={item.title + item.price}
                  title={item.title}
                  price={`${DisplayMoney(item.price)} / ${item.price_type}`}
                  description={item.subtitle}
                />
              ))}
            </Box>
          </>
        )}

        {guidelinesAndRestrictions && guidelinesAndRestrictions.length != 0 && (
          <>
            <Box mt={1} mb={2}>
              <Divider />
            </Box>
            <Typography variant="h4" className={classes.sectionSubTitle}>
              {t('fe_es_vehicle_page:guide_lines_restrictions')}
            </Typography>
            <Typography variant="h5" className={classes.info}>
              <div dangerouslySetInnerHTML={{ __html: guidelinesAndRestrictions }} />
            </Typography>
          </>
        )}
      </Box>
    </>
  );
};

export default withTranslation('fe_es_vehicle_page')(MostRidersAskAbout);
